// Custom directive that registers longpresses

import type { Directive } from "vue"

// How many ms before a pointerdown is being detected as a long press
const DELAY = 500

const longpressEventListenerCache: Array<{ el: HTMLElement, event: keyof HTMLElementEventMap, listener: any }> = []

export const LongpressDirective: Directive<HTMLElement, (event: PointerEvent) => void> = {
  mounted (el, binding) {
    let timeout: number|undefined

    const pointerDownCallback = (ev: PointerEvent) => {
      if (binding.modifiers.prevent === true) {
        ev.preventDefault()
      }
      if (binding.modifiers.stop === true) {
        ev?.stopPropagation()
      }

      timeout = setTimeout(() => binding.value(ev), DELAY)
    }

    el.addEventListener("pointerdown", pointerDownCallback)
    longpressEventListenerCache.push({
      el, event: "pointerdown", listener: pointerDownCallback
    })

    const pointerUpCallback = (ev: PointerEvent) => {
      if (binding.modifiers.prevent === true) {
        ev.preventDefault()
      }
      if (binding.modifiers.stop === true) {
        ev?.stopPropagation()
      }

      clearTimeout(timeout)
    }
    el.addEventListener("pointerup", pointerUpCallback)
    longpressEventListenerCache.push({
      el, event: "pointerup", listener: pointerUpCallback
    })
  },
  beforeUnmount (el) {
    const listeners = longpressEventListenerCache.filter(e => e.el === el)
    for (const entry of listeners) {
      const { el, event, listener } = entry
      const idx = longpressEventListenerCache.indexOf(entry)
      el.removeEventListener(event, listener)
      if (idx > -1) {
        longpressEventListenerCache.splice(idx, 1)
      }
    }
  }
}

declare module "vue" {
  export interface GlobalDirectives {
    vLongpress: Directive<HTMLElement, (event: PointerEvent) => void>
  }
}
